export enum Environment {
  test = 'test',
  local = 'local',
  development = 'development',
  integration = 'integration',
  production = 'production',
}
